<template>
  <div class="home">
    <div class="header">
      <span>FIO WALLET </span>
      <span>| </span>
      <span>LOG IN</span>
    </div>
    <hr>
    <div class="login-check">
      <span>img</span>
      <span>正在检测您的账户安全状态，请稍后。。。。</span>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {

  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>
<style lang="scss">

</style>



